<div class="auth-page-wrap">

    <div class="auth-page-body">

        <div class="auth-panel" @fadeIn>

            <logo class="auth-header-logo">
            </logo>

            <div class="auth-body">

                <div class="auth-body-top">

                    <div class="auth-body-title rpc-title-font">
                        {{ 'LOGIN.TITLES.LOGIN' | translate }}
                    </div>

                    <div class="auth-body-text">
                        {{ 'LOGIN.TITLES.WELCOME_BACK' | translate }}
                    </div>

                </div>

                <form class="auth-form" name="loginForm" [formGroup]="loginForm" novalidate>

                    <div class="auth-form-body">

                        <rpc-input class="auth-form-input" [type]="'email'" [appearance]="'fill'"
                            [autocomplete]="'email'" [label]="'LOGIN.TITLES.USERNAME'"
                            [options]="userNameControlOptions">
                        </rpc-input>

                        <password class="auth-form-input" [autocomplete]="'current-password'"
                            [label]="'LOGIN.TITLES.PASSWORD'" [options]="passwordControlOptions">
                        </password>

                        <div class="auth-link-wrap">

                            <a class="auth-link" [routerLink]="'/' + RpcRoute.ForgotPassword">
                                {{'LOGIN.TITLES.FORGOT_PASSWORD' | translate}}
                            </a>

                        </div>

                    </div>

                    <div class="auth-form-footer">

                        <rpc-button [color]="'accent'" [disabled]="loginForm.invalid" [appearanceType]="'flat'"
                            [text]="'LOGIN.TITLES.LOGIN'" [isMainButton]="true" (clicked)="login()">
                        </rpc-button>

                    </div>

                </form>

            </div>

            <div class="auth-terms">

                <span class="auth-terms-first">
                    {{'LOGIN.TITLES.AGREE_TERMS' | translate}}
                </span>

                <a [href]="termsAndConditionsLink" target="_blank" rel="nofollow">
                    {{'LOGIN.TITLES.TERMS_CONDITIONS' | translate}}
                </a>
                {{'LOGIN.TITLES.AND' | translate}}
                <a [href]="privacyPolicyLink" target="_blank" rel="nofollow">
                    {{'LOGIN.TITLES.PRIVACY_POLICY' | translate}}
                </a>
            </div>

        </div>

    </div>

</div>

<additional-footer class="global-additional-footer">
</additional-footer>